<div class="auto-search-places">
  <app-search-input-all-places
    [searchType]="'AUTOS_RESULTS'"
    [isMobile]="true"
    [icon]="icons.StartPoint"
    [placeType]="pickUp"
    [place]="pickUpPlace$ | async"
    [showError]="isPlacePickUpSelectedEmpty"
    [countryCode]="'SEARCH_MODULE.LOCATION_SEARCH.FROM' | transloco"
    [countryName]="'SEARCH_MODULE.LOCATION_SEARCH.AUTOS_ORIGIN' | transloco"
    [autoCompletePlaces]="autoCompletePlaces$ | async"
    [eventPath]="eventPath | async"
    [arrivalPlace]="dropOffPlace$ | async"
    [departurePlace]="pickUpPlace$ | async"
    (selectPlace)="selectPlace($event, pickUp)"
    [autofocus]=true
    [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces$ | async"
    (inputChanged)="placeInputChanged($event)"
    (removeAutoCompletePlaces)="clearAutocompletePlaces()"
    (locationNotFoundEvent)="locationNotFoundEvent.emit($event)"
    (popularSelected)="popularSelected.emit($event)">
  </app-search-input-all-places>

  <div class="checkbox">
    <input [required]=false formControlName="other_destiny" [value]="true" type="checkbox" [id]="'other_destiny'" [attr.name]="'other_destiny'"
      [attr.value]="'other_destiny'" [ngClass]="addErrorClass('other_destiny')" [checked]="isDiffPlace$ | async" (change)="toggleOrigin()">
    <label [attr.for]="'other_destiny'" clas="item-name">
      <span class="name">
        {{ 'AUTOS_MODULE.SEARCH.RETURN_OTHER_PLACE' | transloco }}
      </span>
    </label>
  </div>

  <div class="auto-arrival-input" *ngIf="isDiffPlace$ | async">
    <app-search-input-all-places
      [searchType]="'AUTOS_RESULTS'"
      [isMobile]="true"
      [icon]="icons.Location"
      [placeType]="dropOff"
      [place]="dropOffPlace$ | async"
      [showError]="isPlaceDropOffSelectedEmpty"
      [countryCode]="'SEARCH_MODULE.LOCATION_SEARCH.TO_MOBILE' | transloco"
      [countryName]="'SEARCH_MODULE.LOCATION_SEARCH.AUTOS_DESTINATION' | transloco"
      [autoCompletePlaces]="autoCompletePlaces$ | async"
      [eventPath]="eventPath | async"
      [arrivalPlace]="dropOffPlace$ | async"
      [departurePlace]="pickUpPlace$ | async"
      (selectPlace)="selectPlace($event, dropOff)"
      [autofocus]=true
      [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces$ | async"
      (inputChanged)="placeInputChanged($event)"
      (removeAutoCompletePlaces)="clearAutocompletePlaces()"
      (locationNotFoundEvent)="locationNotFoundEvent.emit($event)"
      (popularSelected)="popularSelected.emit($event)">
  </app-search-input-all-places>
  </div>
</div>
